import { prop } from 'datx';

import { BaseModel } from './BaseModel';

export class Font extends BaseModel {
  public static type = 'font';

  @prop
  public name!: string;

  @prop
  public style!: string;

  @prop
  public weight!: string;

  @prop
  public fileSources!: Array<string>;
}
